import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './components/App'
import registerServiceWorker from './registerServiceWorker'
import 'tachyons'
import { rgbToHex } from './helper.js'

ReactDOM.render(<App />, document.getElementById('root'))
registerServiceWorker()

const Sigma = window.sigma

Sigma.classes.graph.addMethod('neighbors', function (nodeId) {
	let index = this.allNeighborsIndex[nodeId] || {}
	let neighbors = {}
	for (let k in index)
		neighbors[k] = this.nodesIndex[k]
	return neighbors
});

const s = new Sigma({
	renderer: {
		type: 'canvas',
		container: 'canvas-container'
	},
	settings: Sigma.settings
})

window.sigma_inst = s
window.graph = s.graph

Sigma.plugins.dragNodes(s, s.renderers[0])


function any(iterable) {
	for (const x of iterable)
		if (x) return true
	return false
}

function* zip(...iterables) {
	const iterators = iterables.map(iter => iter[Symbol.iterator]())
	for (let i = 0; ; i++) {
		const xs = iterators.map(it => it.next())
		if (any(xs.map(x => x.done)))
			return
		yield xs.map(x => x.value)
	}
}

fetch('./data/sms2.csv')
	.then(resp => resp.text())
	.then(sms => parseCSV(sms))

function parseCSV(sms) {
	const lines = sms.split('\n').filter(line => line.length > 0)
	const sep = /;/.test(lines[0]) ? ';' : ','
	const headers = lines.shift().split(sep).map((h, i) => h || '#' + i) // TODO better handling of separating chars
	const csvData = headers.map(h => [])
	lines.forEach(line =>
		line.split(sep).forEach((elem, i) =>
			csvData[i].push(elem)))
	const csv = {}
	headers.forEach((h, i) => csv[h] = csvData[i])

	const WEIGHT_SKELETON = 50
	const WEIGHT_SATELLITE = 0.1

	const skeletonNodes = new Set(csv['Source'] || csv[headers[0]])
	const satelliteNodes = new Set(csv['Target'] || csv[headers[1]])

	let previous = null
	skeletonNodes.forEach(node => {
		s.graph.addNode({
			id: node,
			label: node,
			x: Math.random(),
			y: Math.random(),
			size: 1,
			type: 'skeleton',
		})
		if (previous !== null) { // add edge to previous node
			s.graph.addEdge({
				id: previous + '->' + node,
				source: previous,
				target: node,
				weight: WEIGHT_SKELETON,
				type: 'skeleton',
				color: '#000',
				originalColor: '#000',
			})
		}
		previous = node
	})

	satelliteNodes.forEach((node, i) => {
		s.graph.addNode({
			id: node,
			label: node,
			x: Math.random(),
			y: Math.random(),
			size: 2,
			color: '#999', // TODO
			type: 'satellite',
		})
	})

	let maxDegree = 0

	const edges = new Set([...zip(csv['Source'], csv['Target'])].map(([s, t]) => s + '=>' + t))

	// Link the satellites to the skeleton
	edges.forEach((s2t, i) => {
		const [source, target] = s2t.split('=>')
		s.graph.addEdge({
			id: s2t,
			source,
			target,
			weight: WEIGHT_SATELLITE,
			color: '#abc',
			originalColor: '#abc', // TODO c'est quoi ça ?
		})

		maxDegree = Math.max(s.graph.degree(target), maxDegree)

	})

	satelliteNodes.forEach((satellite) => {
		const shade = Math.max(0, Math.round(255 * (1 - s.graph.degree(satellite) / (maxDegree))))
		const hexColor = rgbToHex(shade, shade, shade)
		s.graph.nodes(satellite).color = hexColor
		s.graph.nodes(satellite).originalColor = hexColor
	})

	s.refresh()
}
window.parseCSV = parseCSV

s.bind("overNode", (event) => {

	const graph = event.target.graph

	window.highlighted = { ...window.highlighted, ...graph.neighbors(event.data.node.id) }
	window.highlighted[event.data.node.id] = event.data.node

	Object.entries(window.highlighted).forEach(([id, node]) => {
		graph.nodes(id).color = '#faa'
	})

	graph.edges().forEach((edge) => {
		if (edge.type === 'skeleton')
			edge.color = edge.originalColor
		else if (edge.source === event.data.node.id || edge.target === event.data.node.id)
			edge.color = '#faa'
		else
			edge.color = '#eee'
	})

	event.target.refresh()
})



s.bind("outNode", (event) => {
	// reset original colors

	const graph = event.target.graph

	Object.entries(window.highlighted).forEach(([id, node]) => {
		graph.nodes(id).color = node.originalColor
	})

	graph.edges().forEach((edge) => {
		edge.color = edge.originalColor
	})

	window.highlighted = {}

	event.target.refresh()
})



// WEBPACK FOOTER //
// ./src/index.js